<template>  
    <div class='dataContainer' >
        <ul class="list-group">
            <li class="list-group-item list-group-item-warning" v-show='gotData' >
                <div class="row">
                    <div class="col-xs-12 col-md-6" >  
                        <span class='IndexWidth'    >#</span>
                        <span class='mobiletext'>Titulo:&nbsp;&nbsp;&nbsp;<input v-model='filteredItemName' class='NameWidthHeader'  >&nbsp;&nbsp;<span class='glyphicon glyphicon-search glyphiconSize' ></span></span>
                    </div>
                    <div class="hidden-sm col-md-3" >  
                        <span class='PriorityWidth' >Prioridad</span>
                        <span class='ActiveWidth'   >Activo</span>
                    </div>
                    <div class="hidden-sm col-md-3" >  
                        <span class='btnWidth'      >Detalles</span>
                        <span class='btnWidth'      >Borrar</span>                    
                    </div>
                </div>
            </li>     
            <li class="list-group-item" v-for='(itemDetail, index) in filteredItemNames' v-if='index < 100' >  
                <div class="row">          
                    <div class="col-xs-9 col-md-6" > 
                        <span  class='IndexWidth' >{{ index+1 }}</span>
                        <span> <input class='NameWidth form-control'     type='text' readonly="readonly" v-model='itemDetail.title'></span>
                    </div>                        
                    <div class="hidden-sm col-md-3" > 
                        <span> <input class='PriorityWidth form-control' type='text' readonly="readonly" v-model='itemDetail.priority'></span>                
                        <span  class='ActiveWidth'><span> {{ itemDetail.active ? 'Si' : 'No' }}</span></span>
                    </div>                        
                    <div class="col-xs-3 col-md-3" > 
                        <span  class='btnWidth' >  <button  type="button"   v-bind:class="itemDetail.showDetails ? classUpArrow : classDownArrow" @click='detailsRow(itemDetail)' ></button></span>                                                              
                        <span  class='btnWidth' >  <button  type="button"   class="btn btn-danger glyphicon glyphicon glyphicon-remove glyphiconSize" @click='deleteRow(itemDetail)' ></button></span>                                        
                    </div>
                </div>
                <div v-if='itemDetail.showDetails' >
                    <hr><CarForSaleAdd v-bind:itemDetail="itemDetail" v-bind:dropDownDetails="dropDownDetails" updateItem=true></CarForSaleAdd> <hr>                    
                </div>
            </li>        
        </ul>
        <Pagination v-bind:pagesInfo='pagesInfo' ></Pagination>
    </div>  
</template>

<script>
import { eventBus } from '../../main';
import { CarsDropDownMixin } from '../mixin/CarsDropDownMixin';
import { PaginationMixin } from '../mixin/PaginationMixin';

export default {    
  mixins : [CarsDropDownMixin,PaginationMixin],  
  data: function () {     
    return {
        classDownArrow: 'btn btn-info glyphicon glyphicon-chevron-down glyphiconSize',
        classUpArrow:   'btn btn-info glyphicon glyphicon-chevron-up glyphiconSize',
        newItem: {
            name:'',
            priority: 0,
            active: true,
            deleted: 0
        },      
        ItemsDetails: [],
        filteredItemName: '',
        gotData: false,
        updateItem: true,
        maxItemToShow: 12,
        pagesInfo:[],            
    }
  }, 
  created: function () {               
    this.getCurrency();
    this.getCarBrandDetails();
    this.getCarModelDetails();
    this.getCarColors();
    this.getFuelType();
    this.getTransmissionsType();
    this.getCarType();
    this.getTractionType();                                      
  },
  mounted: function () {                  
      this.getItemsDetails();
      this.getPaginationLinks('/admin/carforsaleadmin/','api/carforsalelist/gettotalcarsforsale', this.maxItemToShow);
  },
  watch: { // whenever question changes, this function will run        
    $route () {        
        this.getItemsDetails();                
    }
  },
  methods: {
    updateParams : function() {
        if(this.$route.params.offset)
            this.offset = this.$route.params.offset;    
        else
            this.offset = 0;     
    },    
    getItemsDetails: function() {   
        this.updateParams();           
        var callUrl = 'api/carforsale/admin/maxresult/' + this.maxItemToShow + '/offset/' +  this.offset;                

        this.$http.get(callUrl).then(response => {                                    
            this.ItemsDetails = response.body.map(obj =>{                                             
                obj.showDetails = false;
                return obj;
            });
            
            this.gotData = true;                     
        }, response => {            
            eventBus.$emit('errorMsg',response);
        });
    },
    detailsRow: function(itemsDetail){
        itemsDetail.showDetails = !itemsDetail.showDetails;        
    },          
    deleteRow: function({id})
    {                        
        this.$http.delete('api/carforsale/' + id).then(response => {                                    
          eventBus.$emit('resultMessage',response);                                   
          this.getItemsDetails();
        }, response => {
            eventBus.$emit('errorMsg',response);
        });
    },        
  },
  filters: {
      
  },
  computed: {
    filteredItemNames: function() {        
        return this.ItemsDetails.filter((element) => {                        
            return element.title.toLowerCase().match(this.filteredItemName.toLowerCase());
        });
    }      
  }
}
</script>

<style scoped>
    .dataContainer{
       width:745px;
       margin-left: 50px;       
       font-weight: 200;
   }

   .IndexWidth {
        display:inline-block;
        width:30px;
        padding-left: 10px;
   }

   .NameWidth {
        display:inline-block;
        width:300px;
   }

   .PriorityWidth {
        display:inline-block;
        width:50%;        
        text-align: right;
        margin-right: 25px;
   }

   .ActiveWidth {
        display:inline-block;
        width:25%;        
        text-align: center;
   }

   .btnWidth{
        width:38%;
        margin-left: 10px;  
        display:inline-block;      
   }   

   .glyphiconSize{
       font-size: 1.4em;
   }

   @media screen and (max-width: 981px) {      

       .IndexWidth {
            font-size: 3em;        
            margin-right: 20px;
            padding-left: 10px;
        }

        .NameWidthHeader {
            display:inline-block;
            width:50%;
            font-size: 1em;
        }   

        .mobiletext {
            font-size: 3em;
        }   

        .NameWidth {
            display:inline-block;
            width:90%;
        }

       .dataContainer{
           width:91%;
       }

        input {        
            position:relative;
            width:100%;
            height:75px;
            font-size: 2.4em;            
        }
    
        button {                    
            position:relative;
            width:80px;
            height:80px;
            font-size: 2.5em;            
        }
   }

   
</style>



// WEBPACK FOOTER //
// CarForSaleAdmin.vue?393122b5